export const MAX_FILE_MB = 100

const MAX_FILE_BYTES = MAX_FILE_MB * 1024 * 1024

export interface ProtectPdfResult {
  blob: Blob
}

export function validateFileSize(file: File): boolean {
  return file.size <= MAX_FILE_BYTES
}

export function protectedFilename(originalName: string): string {
  const dotIndex = originalName.lastIndexOf('.')
  const base = dotIndex !== -1 ? originalName.slice(0, dotIndex) : originalName
  return `${base}-protected.pdf`
}

function generateOwnerPassword(): string {
  const bytes = new Uint8Array(24)
  if (globalThis.crypto?.getRandomValues) {
    globalThis.crypto.getRandomValues(bytes)
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256)
    }
  }

  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')
}

export async function protectPdf(file: File, password: string): Promise<ProtectPdfResult> {
  const { createQpdfRunner } = await import('qpdf-run')
  const runner = await createQpdfRunner({
    workerUrl: new URL('qpdf-run/worker', import.meta.url).href,
    qpdfJsUrl: new URL('qpdf-run/qpdf.js', import.meta.url).href,
    wasmUrl: new URL('qpdf-run/qpdf.wasm', import.meta.url).href,
    timeoutMs: 120_000,
  })

  try {
    const input = new Uint8Array(await file.arrayBuffer())
    const output = await runner.runOne({
      input,
      inputName: 'input.pdf',
      outputName: 'protected.pdf',
      args: [
        '--encrypt',
        password,
        generateOwnerPassword(),
        '256',
        '--print=full',
        '--modify=all',
        '--extract=y',
        '--annotate=y',
        '--form=y',
        '--assemble=y',
        '--accessibility=y',
        '--',
        'input.pdf',
        'protected.pdf',
      ],
    })

    return { blob: new Blob([output], { type: 'application/pdf' }) }
  } finally {
    await runner.destroy()
  }
}
